import { ref, computed } from 'vue';
import { formatUrl, validateUrl } from '@/shared/lib/url-validation';

export { formatUrl, validateUrl } from '@/shared/lib/url-validation';

export function useUrlValidation() {
  const urlValue = ref('');

  const validationResult = computed(() => validateUrl(urlValue.value));
  const isValidUrl = computed(() => validationResult.value.isValid);
  const urlError = computed(() => validationResult.value.error);

  const formattedUrl = computed(() => formatUrl(urlValue.value));

  const validate = (): boolean => {
    const result = isValidUrl.value;
    return result === true;
  };

  const reset = () => {
    urlValue.value = '';
  };

  return {
    urlValue,
    urlError,
    isValidUrl,
    formattedUrl,
    validate,
    reset,
  };
}
